(() => {
  if (customElements.get('ss-service-menu')) return;
  class ServiceMenu extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const button = this.querySelector('.ss-service-menu__toggle');
      const panel = this.querySelector('.topbar__service-dropdown');
      if (!button || !panel) return;
      const setOpen = (open) => {
        panel.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
        button.setAttribute('aria-label', open ? 'Klantenservicemenu sluiten' : 'Klantenservicemenu openen');
      };
      setOpen(false);
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') setOpen(true);
      }, options);
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse' && !this.contains(document.activeElement)) setOpen(false);
      }, options);
      button.addEventListener('click', () => setOpen(panel.hidden), options);
      button.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setOpen(true);
          panel.querySelector('a')?.focus();
        }
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !panel.hidden) {
          event.preventDefault();
          setOpen(false);
          button.focus();
        }
      }, options);
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) setOpen(false);
      }, options);
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) setOpen(false);
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('ss-service-menu', ServiceMenu);
})();
